if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener("product-info:loaded", ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      closeFakeLoginForm() {
        document.querySelector(".form-popup-bg").classList.remove("is-visible");
      }

      openFakeLoginForm() {
        document.querySelector(".form-popup-bg").classList.add("is-visible");
      }

      loginForPriceButtonTriggerForFakeLoginActivation() {
        // debugger;
        const login_for_price_button = document.querySelectorAll(
          `[product-card-button-type="login-for-price"]`
        );
        const login_for_price_button_product_page = document.querySelectorAll(
          `[product-button-type="login-for-price"]`
        );
        var btnCloseForm = document.getElementById("btnCloseForm");
        var formPopupBg = document.querySelector(".form-popup-bg");
        const loginPopUpform = document.querySelector(".login-in-pop-up-form");
        if (login_for_price_button) {
          login_for_price_button.forEach((button) => {
            button.addEventListener("click", (event) => {
              event.preventDefault();
              openForm();
            });
          });
        }
        if (login_for_price_button_product_page) {
          login_for_price_button_product_page.forEach((button) => {
            button.addEventListener("click", (event) => {
              event.preventDefault();
              openForm();
            });
          });
        }
        formPopupBg.addEventListener("click", function (event) {
          if (event.target === formPopupBg || event.target === btnCloseForm) {
            event.preventDefault();
            closeForm();
          }
        });

        const emailInput = loginPopUpform.querySelector("input[type='email']");

        const validateEmail = (email) => {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        };

        const storeTriggeringElement = (element) => {
          const rect = element.getBoundingClientRect();
          sessionStorage.setItem(
            "triggeredElement",
            JSON.stringify({
              top: rect.top + window.scrollY,
              left: rect.left + window.scrollX,
            })
          );
        };

        loginPopUpform.addEventListener("submit", function (event) {
          event.preventDefault();

          const enteredEmail = emailInput.value;

          emailInput.setCustomValidity("");

          if (validateEmail(enteredEmail)) {
            const triggeringElement = document.querySelector(".triggered");
            if (triggeringElement) {
              storeTriggeringElement(triggeringElement);
            }

            localStorage.setItem("customerType", "priceCheckCustomer");
            closeForm();
            window.location.reload();
          } else {
            emailInput.setCustomValidity("Please enter a valid email address.");

            emailInput.reportValidity();
          }
        });

        emailInput.addEventListener("input", function () {
          emailInput.setCustomValidity("");
        });

        window.addEventListener("load", function () {
          const storedPosition = JSON.parse(
            sessionStorage.getItem("triggeredElement")
          );
          if (storedPosition) {
            window.scrollTo({
              top: storedPosition.top,
              left: storedPosition.left,
              behavior: "smooth",
            });
            sessionStorage.removeItem("triggeredElement");
          }
        });
      }

      HideShowLoginPriceBasedOnLogic() {
        if (localStorage.getItem("customerType") == "priceCheckCustomer") {
          const product_card = document.querySelectorAll(
            `.product-card-wrapper`
          );
          const productPageProduct = document.querySelectorAll(
            ".product__info-wrapper"
          );
          if (product_card) {
            product_card.forEach((card) => {
              card.classList.remove("hide_price_based_on_logic");
              card.classList.add("show_price_based_on_logic");
            });
          }
          if (productPageProduct) {
            productPageProduct.forEach((product) => {
              product.classList.remove("hide_price_based_on_logic");
              product.classList.add("show_price_based_on_logic");
            });
          }
        }

        const activatedLogic =
          this.querySelector("[activated-logic]").getAttribute(
            "activated-logic"
          );
        // debugger;
        if (activatedLogic === "logic_one") {
          const infoWrapper = this.querySelector(".product__info-wrapper");

          if (infoWrapper) {
            infoWrapper.classList.remove("hide_price_based_on_logic");
            infoWrapper.classList.add("show_price_based_on_logic");
          }
        }
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        fetch(`${opener.getAttribute("data-product-url")}`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const productElement = responseHTML.querySelector("product-info");

            if (!productElement) {
              throw new Error("Product element not found in fetched HTML.");
            }

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .catch((error) => {
            console.error(
              "Error fetching and processing modal content:",
              error
            );
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
            this.HideShowLoginPriceBasedOnLogic();
            this.loginForPriceButtonTriggerForFakeLoginActivation();
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith("color-") || classApplied === "gradient")
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute("data-update-url", "false");
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(
          oldId,
          newId
        );
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replace(oldId, newId)
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector(".product");
        const desktopColumns = product?.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }
    }
  );
}
